<template>
    <div class="loading-layer" :class="{'fade-out':loaded}">
        <div class="loading-box abs-mm">
            <div class="loading-area">
                <div class="loading-goose" :style="{left:gooseLeft}">
                    <img class="pct100" src="../assets/images/loading.gif" alt="">
                </div>
            </div>
            <div class="progress-bar stripes">
                <span :style="{width:loadingProgress}"></span>
            </div>
            <div class="loading-text">小白鹅正在赶来，稍等片刻...</div>
        </div>
    </div>
</template>
<style rel="stylesheet/scss" lang="scss">
    .loading-layer { width: 100%; height: 100%; position: fixed; left: 0; top: 0; background: linear-gradient(180deg, rgba(105, 28, 202, 1) 0%, rgba(122, 153, 255, 1) 61%, rgba(244, 220, 255, 1) 100%);z-index: 30;}
    .loading-box { width: 100%; }
    .loading-area {width: 3rem;margin: 0 auto 0.1rem auto;}
    .loading-goose {width: 1.03rem;height: 0.6rem;position: relative;transition: left .2s ease-in-out;}
    .loading-bar { width: 3rem; height: 0.17rem; border-radius: 0.2rem; background-color: #5C01D6; margin: 0 auto; overflow: hidden; }
    .loading-text { font-size: 0.13rem; color: #fff; margin-top: 0.1rem; }
    .progress-bar { background-color: #5C01D6; height: 0.17rem; width: 3rem; border-radius: 0.3rem; border: 0.02rem solid #5C01D6; margin: 0 auto;overflow: hidden;}
    .progress-bar span { display: block; height: 100%; border-radius: 0.3rem; transition: width .2s ease-in-out; background-color: #FF6CE5; overflow: hidden;}
    .stripes span { background-size: 30px 30px; background-image: linear-gradient(135deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent); animation: animate-stripes 1s linear infinite; }
    @keyframes animate-stripes {
        0% {background-position: 0 0;}
        100% {background-position: 60px 0;}
        }
    .fade-out { animation: fadeOut 0.3s 1 ease-out both; }
    @keyframes fadeOut {
        0% { opacity: 1; }
        100% { opacity: 0; }
        }
</style>
<script type="javascript">
    export default {
        data() {
            return {
                count: 0,
                loadingPercent: 0,
                loaded: false
            }
        },
        computed: {
            loadingProgress() {
                return this.loadingPercent * 100 + '%'
            },
            gooseLeft() {
                return Math.max(3 * this.loadingPercent - 1, 0) + 'rem'
            }
        },
        mounted() {
            this.preload();
        },
        methods: {
            preload() {
                let self = this;
                //let baseUrl = '//demo.jr.jd.com/member/2020/btgoose'
                let baseUrl = '//active.jd.com/forever/btgoose'
                //let baseUrl = ''
                let imgs = [
                    "/home/balloon.png",
                    "/home/check-icon.png",
                    "/home/cloud-1.png",
                    "/home/cloud-2.png",
                    "/home/egg-icon.png",
                    "/home/ground.png",
                    "/home/guide-goose.png",
                    "/home/head-bg.png",
                    "/home/left-building.png",
                    "/home/mission-icon.png",
                    "/home/mission-panel-close.png",
                    "/home/mission-panel-head.png",
                    "/home/package-icon.png",
                    "/home/reward-icon.png",
                    "/home/right-buildings.png",
                    "/home/scroll-board.png",
                    "/home/shop-icon.png",
                    "/home/shop-panel-top.png",
                    "/home/sky.png",
                    "/stage/exp-bar.png",
                    "/stage/exp-bar-info.png",
                    "/stage/exp-bar-slice.png",
                    "/stage/exp-tips.png",
                    "/stage/main-btn.png",
                    "/stage/main-btn-disable.png",
                    "/stage/main-btn-pushed.png",
                    "/stage/main-stage.png",
                    "/stage/next-egg-board.png",
                    "/stage/stage-egg.png",
                    "/goose/bag.png",
                    "/goose/body.png",
                    "/goose/catch-hand-center.png",
                    "/goose/catch-hand-left.png",
                    "/goose/catch-hand-right.png",
                    "/goose/egg.png",
                    "/goose/glasses.png",
                    "/goose/left-hand.png",
                    "/goose/left-leg.png",
                    "/goose/light-1.png",
                    "/goose/light-2.png",
                    "/goose/light-3.png",
                    "/goose/light-4.png",
                    "/goose/mouth.png",
                    "/goose/nose.png",
                    "/goose/right-hand.png",
                    "/goose/right-leg.png",
                ]
                for (let img of imgs) {
                    let image = new Image()
                    image.onload = function () {
                        self.count++;
                        let percentNum = Math.floor(self.count / imgs.length);
                        self.loadingPercent = percentNum;
                        if (self.count == imgs.length) {
                            self.finishLoading();
                        }
                    }
                    image.onerror = function () {
                        self.count++;
                        let percentNum = Math.floor(self.count / imgs.length);
                        self.loadingPercent = percentNum;
                        if (self.count == imgs.length) {
                            self.finishLoading();
                        }
                    }
                    image.src = baseUrl + img
                }
            },
            finishLoading() {
                //return;
                this.$emit('resource-loaded');
                setTimeout(() => {
                    this.loaded = true;
                }, 200)
                setTimeout(() => {
                    this.$destroy(true);
                    this.$el.parentNode.removeChild(this.$el);
                }, 400)
            }
        }
    }
</script>